// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   Kubersetu Investment Page Glass Styles
   ========================================== */

.investments-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 6rem 1.5rem 4rem 1.5rem;
}

.investments-header {
  text-align: center;
  margin-bottom: 3rem;
}

.investments-header h1 {
  font-size: clamp(2rem, 4vw, 3rem);
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 0.5rem;
}

.investments-header p {
  color: var(--text-muted);
  font-size: 1.1rem;
}

.portfolio-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;
  margin-bottom: 3rem;
}

.portfolio-card {
  flex: 1 1;
  min-width: 260px;
  background: var(--grad-surface);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-lg);
  padding: 2rem;
  box-shadow: var(--shadow-lg);
}

.portfolio-card h3 {
  font-size: 1.1rem;
  color: var(--text-muted);
  margin-bottom: 0.75rem;
}

.portfolio-value {
  font-size: 2.25rem;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 0.5rem;
}

.portfolio-change {
  font-size: 0.95rem;
  color: var(--color-emerald);
  font-weight: 600;
}

.portfolio-stats {
  flex: 2 1;
  display: flex;
  gap: 1rem;
  min-width: 300px;
}

.stat {
  flex: 1 1;
  background: var(--bg-glass-card);
  backdrop-filter: blur(16px);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-md);
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.stat-label {
  font-size: 0.85rem;
  color: var(--text-muted);
  margin-bottom: 0.4rem;
}

.stat-value {
  font-size: 1.35rem;
  font-weight: 700;
  color: #ffffff;
}

.investment-section {
  background: var(--bg-glass-card);
  backdrop-filter: blur(20px);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-lg);
  padding: 2rem;
  margin-bottom: 2.5rem;
}

.section-header h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: #ffffff;
}

.view-all-btn {
  background: none;
  border: none;
  color: #a5b4fc;
  font-weight: 600;
  cursor: pointer;
}

.portfolio-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.25rem;
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-md);
  margin-bottom: 0.75rem;
}

.item-info h4 {
  font-size: 1.1rem;
  color: #ffffff;
  margin-bottom: 0.25rem;
}

.item-info p {
  color: var(--text-muted);
  font-size: 0.85rem;
}

.item-value {
  font-size: 1.2rem;
  font-weight: 700;
  color: #ffffff;
}

.item-change {
  color: var(--color-emerald);
  font-size: 0.85rem;
  font-weight: 600;
}

.investment-tabs {
  display: flex;
  background: rgba(15, 23, 42, 0.7);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-md);
  padding: 0.4rem;
  margin-bottom: 1.5rem;
}

.tab {
  flex: 1 1;
  padding: 0.75rem;
  border: none;
  background: transparent;
  border-radius: var(--radius-sm);
  font-weight: 600;
  color: var(--text-muted);
  cursor: pointer;
  transition: all 0.3s ease;
}

.tab.active {
  background: var(--grad-primary);
  color: #ffffff;
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.4);
}

.investment-card {
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-md);
  padding: 1.5rem;
}

.investment-card h3 {
  font-size: 1.2rem;
  color: #ffffff;
  margin-bottom: 1rem;
}

.label {
  color: var(--text-muted);
  font-size: 0.85rem;
}

.value {
  color: #ffffff;
  font-weight: 600;
}

.value.highlight {
  color: var(--color-emerald);
}

.risk-low { color: var(--color-emerald); }
.risk-medium { color: var(--color-accent); }
.risk-high { color: var(--color-danger); }

.invest-btn {
  width: 100%;
  padding: 0.85rem;
  background: var(--grad-primary);
  color: #ffffff;
  border: none;
  border-radius: var(--radius-full);
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 1rem;
}

.investment-calculator {
  background: var(--bg-glass-card);
  backdrop-filter: blur(20px);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-lg);
  padding: 2.5rem;
}

.investment-calculator h2 {
  font-size: 1.75rem;
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 1.5rem;
}

.amount-value {
  text-align: center;
  font-size: 1.75rem;
  font-weight: 800;
  color: #a5b4fc;
  margin-top: 0.5rem;
}

.result {
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  background: rgba(15, 23, 42, 0.6);
  border-radius: var(--radius-sm);
  border: 1px solid var(--border-glass);
  color: #ffffff;
}

.chart-placeholder {
  display: flex;
  align-items: flex-end;
  gap: 1.5rem;
  height: 200px;
  padding: 1.5rem;
  background: rgba(15, 23, 42, 0.6);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-md);
  width: 100%;
}

.chart-bar {
  flex: 1 1;
  background: var(--grad-primary);
  border-radius: 6px 6px 0 0;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding-top: 0.5rem;
  color: #ffffff;
  font-weight: 700;
  font-size: 0.85rem;
}`, "",{"version":3,"sources":["webpack://./src/Components/Investment.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C;EACE,iBAAiB;EACjB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,+BAA+B;EAC/B,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gCAAgC;EAChC,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,iCAAiC;EACjC,qCAAqC;EACrC,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,YAAY,2BAA2B,EAAE;AACzC,eAAe,0BAA0B,EAAE;AAC3C,aAAa,0BAA0B,EAAE;;AAEzC;EACE,WAAW;EACX,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;EACd,YAAY;EACZ,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,iCAAiC;EACjC,+BAA+B;EAC/B,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,WAAW;EACX,aAAa;EACb,eAAe;EACf,iCAAiC;EACjC,qCAAqC;EACrC,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,SAAO;EACP,+BAA+B;EAC/B,0BAA0B;EAC1B,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB","sourcesContent":["/* ==========================================\n   Kubersetu Investment Page Glass Styles\n   ========================================== */\n\n.investments-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 6rem 1.5rem 4rem 1.5rem;\n}\n\n.investments-header {\n  text-align: center;\n  margin-bottom: 3rem;\n}\n\n.investments-header h1 {\n  font-size: clamp(2rem, 4vw, 3rem);\n  font-weight: 800;\n  color: #ffffff;\n  margin-bottom: 0.5rem;\n}\n\n.investments-header p {\n  color: var(--text-muted);\n  font-size: 1.1rem;\n}\n\n.portfolio-summary {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1.5rem;\n  margin-bottom: 3rem;\n}\n\n.portfolio-card {\n  flex: 1;\n  min-width: 260px;\n  background: var(--grad-surface);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-lg);\n  padding: 2rem;\n  box-shadow: var(--shadow-lg);\n}\n\n.portfolio-card h3 {\n  font-size: 1.1rem;\n  color: var(--text-muted);\n  margin-bottom: 0.75rem;\n}\n\n.portfolio-value {\n  font-size: 2.25rem;\n  font-weight: 800;\n  color: #ffffff;\n  margin-bottom: 0.5rem;\n}\n\n.portfolio-change {\n  font-size: 0.95rem;\n  color: var(--color-emerald);\n  font-weight: 600;\n}\n\n.portfolio-stats {\n  flex: 2;\n  display: flex;\n  gap: 1rem;\n  min-width: 300px;\n}\n\n.stat {\n  flex: 1;\n  background: var(--bg-glass-card);\n  backdrop-filter: blur(16px);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-md);\n  padding: 1.5rem;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n.stat-label {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  margin-bottom: 0.4rem;\n}\n\n.stat-value {\n  font-size: 1.35rem;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.investment-section {\n  background: var(--bg-glass-card);\n  backdrop-filter: blur(20px);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-lg);\n  padding: 2rem;\n  margin-bottom: 2.5rem;\n}\n\n.section-header h2 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.view-all-btn {\n  background: none;\n  border: none;\n  color: #a5b4fc;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.portfolio-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 1.25rem;\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-md);\n  margin-bottom: 0.75rem;\n}\n\n.item-info h4 {\n  font-size: 1.1rem;\n  color: #ffffff;\n  margin-bottom: 0.25rem;\n}\n\n.item-info p {\n  color: var(--text-muted);\n  font-size: 0.85rem;\n}\n\n.item-value {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.item-change {\n  color: var(--color-emerald);\n  font-size: 0.85rem;\n  font-weight: 600;\n}\n\n.investment-tabs {\n  display: flex;\n  background: rgba(15, 23, 42, 0.7);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-md);\n  padding: 0.4rem;\n  margin-bottom: 1.5rem;\n}\n\n.tab {\n  flex: 1;\n  padding: 0.75rem;\n  border: none;\n  background: transparent;\n  border-radius: var(--radius-sm);\n  font-weight: 600;\n  color: var(--text-muted);\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.tab.active {\n  background: var(--grad-primary);\n  color: #ffffff;\n  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.4);\n}\n\n.investment-card {\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-md);\n  padding: 1.5rem;\n}\n\n.investment-card h3 {\n  font-size: 1.2rem;\n  color: #ffffff;\n  margin-bottom: 1rem;\n}\n\n.label {\n  color: var(--text-muted);\n  font-size: 0.85rem;\n}\n\n.value {\n  color: #ffffff;\n  font-weight: 600;\n}\n\n.value.highlight {\n  color: var(--color-emerald);\n}\n\n.risk-low { color: var(--color-emerald); }\n.risk-medium { color: var(--color-accent); }\n.risk-high { color: var(--color-danger); }\n\n.invest-btn {\n  width: 100%;\n  padding: 0.85rem;\n  background: var(--grad-primary);\n  color: #ffffff;\n  border: none;\n  border-radius: var(--radius-full);\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-top: 1rem;\n}\n\n.investment-calculator {\n  background: var(--bg-glass-card);\n  backdrop-filter: blur(20px);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-lg);\n  padding: 2.5rem;\n}\n\n.investment-calculator h2 {\n  font-size: 1.75rem;\n  font-weight: 800;\n  color: #ffffff;\n  margin-bottom: 1.5rem;\n}\n\n.amount-value {\n  text-align: center;\n  font-size: 1.75rem;\n  font-weight: 800;\n  color: #a5b4fc;\n  margin-top: 0.5rem;\n}\n\n.result {\n  display: flex;\n  justify-content: space-between;\n  padding: 1rem;\n  background: rgba(15, 23, 42, 0.6);\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border-glass);\n  color: #ffffff;\n}\n\n.chart-placeholder {\n  display: flex;\n  align-items: flex-end;\n  gap: 1.5rem;\n  height: 200px;\n  padding: 1.5rem;\n  background: rgba(15, 23, 42, 0.6);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-md);\n  width: 100%;\n}\n\n.chart-bar {\n  flex: 1;\n  background: var(--grad-primary);\n  border-radius: 6px 6px 0 0;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  padding-top: 0.5rem;\n  color: #ffffff;\n  font-weight: 700;\n  font-size: 0.85rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
